module.exports = __webpack_public_path__ + "img/qr_relation.dc067009.png";